import { GiPlatform } from "react-icons/gi";
import { AiOutlineSolution } from "react-icons/ai";
import { RxSection } from "react-icons/rx";
import { TiContacts } from "react-icons/ti";
import { BsBusFront, BsTrainFreightFront } from "react-icons/bs";
import { BiBus } from "react-icons/bi";

export const TransportCategories = [
  "bus",
  "train",
  "launch",
  "plane",
  "metro",
  "water taxi",
  "cng",
  "auto",
  "leguna",
  "car",
  "motorcycle",
  "rickshaw",
];

export const RoutePath = {
  platform: "topbar",
  solutions: "local",
  productAdd: "local/add",
  productUnique: "local/:id",
  productDetails: "intercity",
  intercityAdd: "intercity/add",
  intercityUnique: "intercity/:id",
  productList: "instruction",
  reviewList: "contact",
  footer: "footer",
  manageUser: "manage-user",

  whyUs: "why-us",
  clientList: "clients",
  clientAdd: "client/add",
  clientUnique: "client/:id",
  reviewAdd: "review/add",
  reviewUnique: "review/:id",
  login: "login",
};

export const sideBarNavigation = [
  {
    title: "Topbar",
    url: RoutePath.platform,
    icon: <GiPlatform />,
  },
  {
    title: "Local Transport",
    url: RoutePath.solutions,
    icon: <BiBus />,
  },
  {
    title: "Intercity Transport",
    url: RoutePath.productDetails,
    icon: <BsTrainFreightFront />,
  },
  // {
  //   title: "Our Clients",
  //   url: RoutePath.clientList,
  //   icon: <IoPeopleOutline />,
  // },
  // {
  //   title: "products",
  //   url: "#",
  //   icon: <BsBoundingBox />,
  //   subUrl: [
  //     {
  //       title: "Products details",
  //       url: `${RoutePath.productDetails}`,
  //     },
  //     {
  //       title: "Products list",
  //       url: `${RoutePath.productList}`,
  //     },
  //   ],
  // },
  // {
  //   title: "why bangla haat",
  //   url: RoutePath.whyUs,
  //   icon: <SiCountingworkspro />,
  // },
  {
    title: "Instructions",
    url: RoutePath.productList,
    icon: <AiOutlineSolution />,
  },
  {
    title: "Contact Us",
    url: RoutePath.reviewList,
    icon: <TiContacts />,
  },
  {
    title: "Footer",
    url: RoutePath.footer,
    icon: <RxSection />,
  },
];

export const apiPath = {
  homeApi: "home",
  localApi: "local",
  intercityApi: "intercity",

  clientsApi: "clients",
  productApi: "product",
  productsApi: "products",
  footerApi: "footer",
  userListApi: "user/list",
};

export const getToken = () => {
  const tempToken = sessionStorage.getItem("ebc202c5c66c906f41dfee622fb64242")
    ? sessionStorage.getItem("ebc202c5c66c906f41dfee622fb64242")
    : "69420";

  return decryptToken(tempToken);
};

export const decryptToken = (tempToken) => {
  let charPlace = tempToken.indexOf(".");
  let payLoad = tempToken.slice(0, charPlace + 1);
  let legitToken = tempToken.slice(charPlace + 11);
  return payLoad + legitToken;
};
